import {SET_STD_EDU_PROFILE, SET_STD_HTR_PROFILE, SET_STD_MJ_CHANGE_PROFILE} from '../actionTypes'

export default function (state = {}, action) {
    //console.log(action.type);
    //console.log(action.payload);
    switch (action.type) {
        case SET_STD_EDU_PROFILE:
            console.log("SET_STD_EDU_PROFILE", action)
            return {...state, education: action.payload}

        case SET_STD_HTR_PROFILE:
            console.log("SET_STD_HTR_PROFILE", action)
            return {...state, statusHistory: action.payload}

        case SET_STD_MJ_CHANGE_PROFILE:
            console.log("SET_STD_MJ_CHANGE_PROFILE", action)
            return {...state, majorChange: action.payload}

        default:
            return state
    }
}
